<template>
<div class="dyn-textarea">
  <div v-html="htmlValue"></div>
  <textarea :placeholder="placeholder" :value="value" v-on:input="$emit('input', $event.target.value)"></textarea>
</div>
</template>
<script>
export default {
  props: ["value", "placeholder"],
  computed: {
    htmlValue() {
      var val=this.value || " ";
      return val.replace(/\</g, "&lt;")
                .replace(/\>/g, "&gt;")
                .replace(/\"/g, "&quot;")
                .replace(/&/g, "&amp;")
                .replace(/\n/g, "<br />")
                .replace(/  /g, "&nbsp; ")
                .replace(/^ /, "&nbsp;")
                .replace(/ $/, "&nbsp;");
    },
  },
}
</script>
